import type { ScanAgentUnavailableReason } from './scan-agent';

export interface UnavailableExplanation {
  /** The sheet's headline: what is wrong, in a few words. */
  title: string;
  /** The one thing to do, in one short line. */
  detail: string;
  /** Whether the download is the thing to show first (Paige Scan is not on this computer). */
  install: boolean;
  /** Whether the sheet finds Paige Scan by itself once it runs (useScanAgent's recheck), so no Try again. */
  waits: boolean;
}

/**
 * One reason, one thing to do, short enough to read at a glance (Dustin, 2026-10-03: the sheet was
 * "super text heavy"). The port number is never in the words: a person can do nothing with it and
 * the page sweeps the ports itself.
 */
const explanations: Record<ScanAgentUnavailableReason, UnavailableExplanation> = {
  not_installed: {
    title: 'Scan with your scanner',
    detail: 'One small app connects your scanner to Paige.',
    install: true,
    waits: true,
  },
  agent_off: {
    title: 'Start Paige Scan',
    detail: 'Open Paige Scan from the Start menu on this computer.',
    install: false,
    waits: true,
  },
  blocked_by_browser: {
    title: 'Your browser blocked Paige Scan',
    detail: 'Click the icon left of the address bar and allow Local network access.',
    install: false,
    waits: false,
  },
  wrong_site: {
    title: 'Paige Scan needs your OK',
    detail: 'Answer Yes when Paige Scan asks on this computer, or reinstall it.',
    install: false,
    waits: false,
  },
  no_scanners: {
    title: 'No scanner found',
    detail: 'Check the scanner’s cable and power, then try again.',
    install: false,
    waits: false,
  },
};

export function explainUnavailable(reason: ScanAgentUnavailableReason): UnavailableExplanation {
  return explanations[reason];
}
